module.exports = __webpack_public_path__ + "static/img/r-5-3-icon.b6c688a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/r-5-3-icon.png
// module id = Q65j
// module chunks = 0